<template>
  <div
    class="fixed flex rounded justify-between items-center p-4 m-auto left-0 right-0"
    :class="info.success ? 'bg-green-light' : 'bg-red-light'"
    style="z-index: 999999999999; "
  >
    <div class="flex items-center">
      <svg
        v-if="info.success"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM13.707 8.707C13.8892 8.5184 13.99 8.2658 13.9877 8.0036C13.9854 7.7414 13.8802 7.49059 13.6948 7.30518C13.5094 7.11977 13.2586 7.0146 12.9964 7.01233C12.7342 7.01005 12.4816 7.11084 12.293 7.293L9 10.586L7.707 9.293C7.5184 9.11084 7.2658 9.01005 7.0036 9.01233C6.7414 9.0146 6.49059 9.11977 6.30518 9.30518C6.11977 9.49059 6.0146 9.7414 6.01233 10.0036C6.01005 10.2658 6.11084 10.5184 6.293 10.707L8.293 12.707C8.48053 12.8945 8.73484 12.9998 9 12.9998C9.26516 12.9998 9.51947 12.8945 9.707 12.707L13.707 8.707Z"
          fill="#20C997"
        />
      </svg>
      <svg
        v-else
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM8.707 7.293C8.5184 7.11084 8.2658 7.01005 8.0036 7.01233C7.7414 7.0146 7.49059 7.11977 7.30518 7.30518C7.11977 7.49059 7.0146 7.7414 7.01233 8.0036C7.01005 8.2658 7.11084 8.5184 7.293 8.707L8.586 10L7.293 11.293C7.19749 11.3852 7.12131 11.4956 7.0689 11.6176C7.01649 11.7396 6.9889 11.8708 6.98775 12.0036C6.9866 12.1364 7.0119 12.2681 7.06218 12.391C7.11246 12.5139 7.18671 12.6255 7.2806 12.7194C7.3745 12.8133 7.48615 12.8875 7.60905 12.9378C7.73194 12.9881 7.86362 13.0134 7.9964 13.0123C8.12918 13.0111 8.2604 12.9835 8.3824 12.9311C8.50441 12.8787 8.61475 12.8025 8.707 12.707L10 11.414L11.293 12.707C11.4816 12.8892 11.7342 12.99 11.9964 12.9877C12.2586 12.9854 12.5094 12.8802 12.6948 12.6948C12.8802 12.5094 12.9854 12.2586 12.9877 11.9964C12.99 11.7342 12.8892 11.4816 12.707 11.293L11.414 10L12.707 8.707C12.8892 8.5184 12.99 8.2658 12.9877 8.0036C12.9854 7.7414 12.8802 7.49059 12.6948 7.30518C12.5094 7.11977 12.2586 7.0146 11.9964 7.01233C11.7342 7.01005 11.4816 7.11084 11.293 7.293L10 8.586L8.707 7.293Z"
          fill="#FF5252"
        />
      </svg>
      <p
        class="px-4 text-base font-semibold"
        :class="info.success ? 'text-green-dark' : 'text-red-dark'"
      >
        {{ info.message }}
      </p>
    </div>
    <svg
      @click="close"
      class="cursor-pointer"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.01" width="20" height="20" fill="white" />
      <path
        :fill="info.success ? '#03543f' : '#540303'"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.43442 5.43442C5.58445 5.28444 5.78789 5.20019 6.00002 5.20019C6.21216 5.20019 6.4156 5.28444 6.56562 5.43442L10 8.86882L13.4344 5.43442C13.5082 5.35801 13.5965 5.29706 13.6941 5.25514C13.7917 5.21321 13.8967 5.19114 14.0029 5.19022C14.1091 5.18929 14.2145 5.20953 14.3128 5.24976C14.4111 5.28998 14.5004 5.34939 14.5755 5.4245C14.6507 5.49961 14.7101 5.58894 14.7503 5.68725C14.7905 5.78557 14.8107 5.89091 14.8098 5.99714C14.8089 6.10336 14.7868 6.20834 14.7449 6.30594C14.703 6.40354 14.642 6.49182 14.5656 6.56562L11.1312 10L14.5656 13.4344C14.7114 13.5853 14.792 13.7874 14.7902 13.9971C14.7883 14.2069 14.7042 14.4075 14.5559 14.5559C14.4076 14.7042 14.2069 14.7883 13.9971 14.7902C13.7874 14.792 13.5853 14.7113 13.4344 14.5656L10 11.1312L6.56562 14.5656C6.41474 14.7113 6.21266 14.792 6.0029 14.7902C5.79315 14.7883 5.5925 14.7042 5.44417 14.5559C5.29584 14.4075 5.21171 14.2069 5.20989 13.9971C5.20806 13.7874 5.2887 13.5853 5.43442 13.4344L8.86882 10L5.43442 6.56562C5.28445 6.41559 5.2002 6.21215 5.2002 6.00002C5.2002 5.78788 5.28445 5.58444 5.43442 5.43442Z"
      />
    </svg>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Alert',
  props: ['info'],
  methods: {
    ...mapMutations(['setUserMessageShowing', 'setUserMessage']),
    close() {
      this.setUserMessageShowing(false);
      this.setUserMessage(null);
    },
  },
};
</script>
